import { UserProfile } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { bookWorkoutSliderCardPressed as bookWorkoutSliderCardPressedAction } from '../../Bookings/actions';
import { HorizontalScrollerCard } from './HorizontalScrollerCard';
import WorkoutSectionCardWithImageContentWrapper from './WorkoutSectionCardWithImageContentWrapper';
import { workoutSliderCardStyle } from './WorkoutSlider';

interface IProps {
  onlyOneCardInSlider: boolean;
  lastCardInSlider: boolean;
  bookWorkoutSliderCardPressed: () => void;
  userProfile: UserProfile;
  navigation: {
    navigate: (route: string) => void;
  };
  t: (key: string) => string;
}

const BookWorkoutSliderCard: FunctionComponent<IProps> = (
  {
    onlyOneCardInSlider,
    lastCardInSlider,
    bookWorkoutSliderCardPressed,
    t,
  },
) => {

  const PTGroupImageHeight = 515;
  const PTGroupImageWidth = 643;

  return (
    <HorizontalScrollerCard
      style={workoutSliderCardStyle.container}
      onPress={bookWorkoutSliderCardPressed}
      wideCard={onlyOneCardInSlider}
      lastCard={lastCardInSlider}
    >
      <WorkoutSectionCardWithImageContentWrapper
        imageHeight={PTGroupImageHeight}
        imageWidth={PTGroupImageWidth}
        header={t('letsWorkout')}
        subHeading={t('startOrScheduleNow')}
        image={require('../../assets/images/pt_group.png')}
      />
    </HorizontalScrollerCard>
  );
};

const mapDispatchToProps = (dispatch, ownProps: IProps) => {
  const { userProfile } = ownProps;
  return {
    bookWorkoutSliderCardPressed: () => dispatch(bookWorkoutSliderCardPressedAction(userProfile)),
  };
};

export default connect(null, mapDispatchToProps)(BookWorkoutSliderCard);
